'use client'

import { FC, useMemo } from "react";
import { MenuItem, Pagination, Select, useMediaQuery, useTheme } from "@mui/material";
import { Container, PageSizeBox } from "./styled";
import { ArrowDown } from "@/components";
import { ITEMS_PER_PAGE } from "@/constants";

export interface CustomPaginationProps {
  page: number;
  numFound?: number,
  itemsPerPage?: number,
  onPageChange: (page: number) => void;
  onItemsPerPageChange?: (value: number) => void;
}

export const CustomPagination: FC<CustomPaginationProps> = ({
  page,
  numFound,
  onPageChange,
  onItemsPerPageChange,
  itemsPerPage = ITEMS_PER_PAGE[25]
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const totalPages = useMemo(() => {
    const totalItems = typeof numFound === "number" ? Math.max(0, numFound) : 0;
    const perPage = itemsPerPage > 0 ? itemsPerPage : (ITEMS_PER_PAGE[25] ?? 25);
    const pages = Math.ceil(totalItems / perPage);
    return Math.max(1, pages);
  }, [numFound, itemsPerPage]);

  return (
    <Container
    >
      {onItemsPerPageChange && (
        <PageSizeBox>
          <Select
            size="small"
            value={itemsPerPage}
            onChange={(e) => onItemsPerPageChange(Number(e.target.value))}
            sx={{
              height: '32px',
            }}
            IconComponent={(props) => <ArrowDown {...props} />}
            inputProps={{ 'aria-label': 'Items per page' }}
          >
            {Object.values(ITEMS_PER_PAGE).map((size) => (
              <MenuItem key={size} value={size}>
                {size}
              </MenuItem>
            ))}
          </Select>
        </PageSizeBox>
      )}

      <Pagination
        count={totalPages}
        page={page + 1}
        onChange={(_, newPage) => onPageChange(newPage - 1)}
        color="secondary"
        shape="rounded"
        size={isMobile ? "small" : "medium"}
      />
    </Container>
  );
};